// Auth thunks — one per API call, all following the project-wide pattern:
// toggle the global loading flag, call the module's api.js, and either
// resolve with the response or rejectWithValue(error) so the component can
// show the failure. All other modules' thunk.js files look the same.
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setGlobalLoading } from "../../../redux/slice";
import * as api from "../api";

export const doSignIn = createAsyncThunk(
  "auth/doSignIn",
  async (params, thunkAPI) => {
    try {
      thunkAPI.dispatch(setGlobalLoading(true));
      const { response, error } = await api.signIn(params);
      thunkAPI.dispatch(setGlobalLoading(false));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doSignUp = createAsyncThunk(
  "auth/doSignUp",
  async (params, thunkAPI) => {
    try {
      thunkAPI.dispatch(setGlobalLoading(true));
      const { response, error } = await api.signUp(params);
      thunkAPI.dispatch(setGlobalLoading(false));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doForgotPassword = createAsyncThunk(
  "auth/doForgotPassword",
  async (params, thunkAPI) => {
    try {
      thunkAPI.dispatch(setGlobalLoading(true));
      const { response, error } = await api.forgotPassword(params);
      thunkAPI.dispatch(setGlobalLoading(false));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doResetPassword = createAsyncThunk(
  "auth/doResetPassword",
  async (params, thunkAPI) => {
    try {
      thunkAPI.dispatch(setGlobalLoading(true));
      const { response, error } = await api.resetPassword(params);
      thunkAPI.dispatch(setGlobalLoading(false));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);
